"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const add = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-add` : '') + (description ? ` desc-add` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-add"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-add"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.8907 0.756307C11.4244 0.810462 11.0625 1.20672 11.0625 1.6875L11.062 11.062L1.6875 11.0625L1.57743 11.0693C1.0984 11.1337 0.75 11.5295 0.75 12L0.756307 12.1093C0.810462 12.5756 1.20672 12.9375 1.6875 12.9375L11.062 12.937L11.0625 22.3125L11.0693 22.4226C11.1337 22.9016 11.5295 23.25 12 23.25L12.1093 23.2437C12.5756 23.1895 12.9375 22.7933 12.9375 22.3125L12.937 12.937L22.3125 12.9375L22.4226 12.9307C22.9016 12.8663 23.25 12.4705 23.25 12L23.2437 11.8907C23.1895 11.4244 22.7933 11.0625 22.3125 11.0625L12.937 11.062L12.9375 1.6875L12.9307 1.57743C12.8663 1.0984 12.4705 0.75 12 0.75L11.8907 0.756307Z",
    fill: "inherit"
  }));
};
var _default = exports.default = add;